import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ContentLanguagesService } from '../fi-services/content-languages.service';

@Component({
    selector: 'fi-mobile-languages-select',
    templateUrl: './mobile-languages-select.component.html',
    styleUrls: ['./mobile-languages-select.component.scss'],
    standalone: false,
})
export class MobileLanguagesSelectComponent implements OnInit {
    @Input() languageId;
    @Output() languageSelected = new EventEmitter<number>();

    DataSet: any[];

    constructor(private contentLanguagesService: ContentLanguagesService) {}

    ngOnInit() {
        this.DataSet = this.contentLanguagesService.GetDropdownListSettingsLanguage().dataSet;
    }

    IsSelected(lang) {
        return this.languageId == lang.Id;
    }

    SelectLanguage(lang) {
        this.languageId = lang.Id;
        this.languageSelected.emit(this.languageId);
    }
}
